import { render, staticRenderFns } from "./noPay.vue?vue&type=template&id=05772956&scoped=true"
import script from "./noPay.vue?vue&type=script&lang=js"
export * from "./noPay.vue?vue&type=script&lang=js"
import style0 from "./noPay.vue?vue&type=style&index=0&id=05772956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05772956",
  null
  
)

export default component.exports